import React, { useEffect, useState } from "react"

import { Link } from "gatsby"

import { ButtonNav } from "../../Buttons"
import MobileMenu from "../MobileMenu"
import StoryS from "../../SVGs/StoryS"

import {
  NavbarContainer,
  NavbarInnerContainer,
  NavbarLogoContainer,
  NavbarLogoText,
  NavbarLogoBar,
  NavbarLogoBrand,
  NavbarList,
  NavbarItem,
  NavbarLink,
  NavbarMobileBtn,
  NavbarMobileBtnLine,
} from "./NavbarElements"

const Navbar = ({ toggle, setTransparent }) => {
  //SCROLL ANIMATION
  const [scrolled, setScrolled] = useState(0)
  const [scrolledNav, setScrolledNav] = useState(0)
  const [bgTransition, setBgTransition] = useState(true)

  useEffect(() => {
    if (
      window.location.pathname === "/" ||
      window.location.pathname === "/shepherd/" ||
      window.location.pathname === "/industries/agriculture" ||
      window.location.pathname === "/industries/non-profit" ||
      setTransparent
    ) {
      window.onscroll = () => {
        setScrolled(window.pageYOffset)
        setScrolledNav(window.pageYOffset)
      }
    } else {
      setBgTransition(false)
      setScrolledNav(1)
      window.onscroll = () => {
        setScrolled(window.pageYOffset)
      }
    }
  }, [])

  return (
    <NavbarContainer
      scrolledNav={scrolledNav}
      scrolled={scrolled}
      bgTransition={bgTransition}
    >
      <NavbarInnerContainer>
        <Link to="/">
          <NavbarLogoContainer>
            <StoryS />
            <NavbarLogoText scrolled={scrolled}>tory</NavbarLogoText>
            <NavbarLogoBar scrolled={scrolled} />
            <NavbarLogoBrand scrolled={scrolled}>
              digital <br></br> marketing
            </NavbarLogoBrand>
          </NavbarLogoContainer>
        </Link>
        <NavbarList>
          <NavbarItem>
            <NavbarLink to={"/services"} onClick={toggle}>
              services
            </NavbarLink>
          </NavbarItem>

          <NavbarItem>
            <NavbarLink to={"/team"} onClick={toggle}>
              meet your team
            </NavbarLink>
          </NavbarItem>
          <NavbarItem>
            <NavbarLink to={"/clients"} onClick={toggle}>
              portfolio
            </NavbarLink>
          </NavbarItem>
          <NavbarItem>
            <NavbarLink to={"/learn"} onClick={toggle}>
              learn
            </NavbarLink>
          </NavbarItem>
          <NavbarItem>
            <ButtonNav
              text={"let’s chat"}
              link={"/contact"}
              onClick={toggle}
              textMargin={"4rem"}
            />
          </NavbarItem>
          {/* <NavbarMobileBtn onClick={toggle}>
            <NavbarMobileBtnLine />
            <NavbarMobileBtnLine />
            <NavbarMobileBtnLine />
          </NavbarMobileBtn> */}
        </NavbarList>
      </NavbarInnerContainer>
    </NavbarContainer>
  )
}

export default Navbar
